import React from 'react'
import './Loader.css'

function Loader() {
    return (
        <div class="mask" id="loader">
            <div class="loader"></div>
        </div>
    )
}

export default Loader
